var Handlebars = require("../../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<li>\n  <a class=\"btn-tab btn-add-new\"><i class=\"fa fa-md fa-fw fa-plus\"></i> Add Report</a>\n</li>\n";
},"useData":true});